<template>
    <div class="container">
        <div class="content">
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small" label-width="64px">
                <el-form-item label="员工姓名">
                    <el-autocomplete class="inline-input" v-model="searchForm.reallyName" :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"
                        clearable></el-autocomplete>
                </el-form-item>
                <el-form-item label="所属部门">
                    <el-cascader @change="handleSelectOrgId" v-model="searchForm.orgId1" :options="options" :show-all-levels="false" :props="{
                        checkStrictly: true,
                        label: 'orgName',
                        value: 'orgPath',
                        children: 'children',
                    }" clearable filterable></el-cascader>
                </el-form-item>

                <el-form-item style="float: right;margin-right: 0px;">
                    <div style="display: flex;">
                        <div class="s-btn" @click="fetchData('search')">查询</div>
                        <div class="r-btn" @click="fetchData('reset')">重置</div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="line"></div>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <el-tabs v-model="tab" class="custom-tabs1">
                        <el-tab-pane :label="'已离职（' + totalNum + '）'" name="1"></el-tab-pane>
                    </el-tabs>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" style="margin-right: 12px;" @click="deliverData()">
                        <img src="../../../assets/icon_daochu.png" style="width: 16px;height: 16px;" />
                        <div class="btn-l">导出列表</div>
                    </div>
                </div>
            </div>
            <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
            </lb-table>

        </div>
        <!-- 查看员工浮层 -->
        <view-employment ref="viewEmployment"></view-employment>
    </div>
</template>
<script>
import eldate from '../../../components/eldate.vue'
import LbTable from '../../../components/lb-table/lb-table'
import viewEmployment from '@/components/viewEmployment'
export default {
    name: 'roster',
    components: {
        eldate,
        LbTable,
        viewEmployment
    },
    data() {
        return {
            tab: '1',
            showCalendar: true,
            statuss: [
                { dictId: 1, dictName: '在职' },
                { dictId: 2, dictName: '离职' },
                { dictId: 3, dictName: '待入职' }
            ],
            searchForm: {
                reallyName: '',
                orgId: null, //
                orgId1: [], // 	否 	string 	商品名称
                pageNo: 1,
                pageSize: 10,
                status: 'S',
                allFlag: 0,
                ids: []

            },
            form: {
                name: ''
            },
            page: {
                pageNo: 1,
                pageSize: 10
            },
            list: [],
            totalNum: 0,
            columns: [
                { type: 'selection', minWidth: '60' },
                { label: '员工姓名', prop: 'reallyName', width: '160' },
                { label: '员工工号', prop: 'serial', minWidth: '120' },
                { label: '登录手机号', prop: 'phoneNumber', minWidth: '140' },

                { label: '性别', prop: 'sexLabel', minWidth: '80' },
                { label: '所属部门', prop: 'orgName', minWidth: '120' },
                { label: '入职日期', prop: 'employeeDate', width: '120' },
                { label: '离职日期', prop: 'leaveTime', width: '120' },
                { label: '职位', prop: 'positionName', minWidth: '120' },
                { label: '聘用形式', prop: 'jobNatureLabel', minWidth: '120' },
                { label: '交接人', prop: 'handoverPerson', minWidth: '120' },
                {
                    label: '操作', prop: 'orgName', minWidth: '80', fixed:"right",
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:center">
                                <div style="color:#00B498;cursor:pointer;" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>

                            </div>
                        )
                    }
                },
            ],
            arr1: [
                {}, {

                }
            ],
            options: [],
            detail: {},
        }
    },
    created() {
        console.log(111)
        this.department()
        this.fetchData()
    },
    mounted() {

    },
    methods: {
        back() {
            this.$router.go(-1)

        },
        querySearch(queryString, cb) {
            this.axios
                .get('/oa/sys/employee/superior/' + this.searchForm.reallyName)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item) => {
                            item.value = item.name
                        })
                        this.staffs = res.data
                        var staffs = this.staffs;
                        var results = queryString ? staffs : [];
                        // 调用 callback 返回建议列表的数据
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            cb(results);
                        }, 3000 * Math.random());
                        // cb(results);
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        deliverData() {
            if (this.searchForm.ids.length == 0) {
                this.$message.warning('请勾选导出的数据')
            } else {
                this.axios.post('/oa/sys/employee/export', this.searchForm).then(res => {
                    if (res.code == 0) {
                        this.downloadlink(res.data)
                        this.$message({
                            type: 'success',
                            message: '导出成功!'
                        })

                    }
                })
            }

        },
        downloadlink(url) {
            const iframe = document.createElement('iframe')
            iframe.style.display = 'none'
            iframe.src = url
            document.body.appendChild(iframe)
        },
        onMultipleSelection(val) {
            // if (val.length == this.page.pageSize) {
            //     this.searchForm.allFlag = 1
            // }
            if (val) {
                this.searchForm.ids = val.map((item) => {
                    return item.id
                })
            }

        },
        handleSelect(item) {
            this.searchForm.reallyName = item.name

        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        fetchData(type) {
            if (type == 'reset') {
                this.searchForm = {
                    status: 'S',
                    orgId: null,
                    orgId1: [],
                    reallyName: '',
                    pageNo: 1,
                    pageSize: 10,
                    allFlag: 0,
                    ids: []
                }
               this.page.pageNo = 1;
            }           
            this.searchForm.pageNo = this.page.pageNo
            this.searchForm.pageSize = this.page.pageSize
            if (type == 'search') {
                this.searchForm.pageNo = 1
                this.page.pageNo = 1
            }
            if (this.searchForm.orgId1) {
                this.searchForm.orgId = this.searchForm.orgId1[this.searchForm.orgId1.length - 1]
            }
            this.searchForm.ids = []
            this.axios.post('/oa/sys/employee/page', this.searchForm).then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.list = res.data.list || []
                    this.totalNum = res.data.totalNum
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleSelectOrgId(e) {
            this.searchForm.orgId = e
        },
        // 部门选择列表
        department() {
            this.axios
                .post(
                    "/sys/v1/org/tree/select",
                    {
                        request: {
                            orgName: "",
                            orgType: "",
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.options = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        lookDetail(val) {
            this.$refs.viewEmployment.show(val.id)
        },
        add() {
            this.$router.push({ path: '/staffManagement/addSatff' })
        },
        getList() {
            this.axios.post('sys/v2/user/employee/pageList', {}).then((res) => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.totalNum = res.data.totalNum
                }
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        min-height: calc(100vh - 118px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
        padding-bottom: 16px;
        border-bottom: 32px solid #F5FAF9;
        border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;
        .search-form {
            padding-top: 32px;
        }

        .line {
            width: 100%;
            height: 1px;
            background: #EDF2F2;
            border-radius: 0px 0px 0px 0px;
            margin-top: 16px;
            clear: both;
        }

        .data-title {
            width: 100%;
            height: 32px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-line {
                width: 2px;
                height: 16px;
                background: #00B498;
                border-radius: 0px 0px 0px 0px;
                margin-top: 8px;
            }

            .title-name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
                margin-left: 4px;
                line-height: 32px;
            }

            .title-btn {
                display: flex;

                .title-btn-item {
                    width: 92px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E3E6E5;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-left: 8px;
                    padding-right: 8px;
                    box-sizing: border-box;
                    cursor: pointer;

                    .btn-l {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #2F3030;

                    }
                }


            }
        }
    }


}

.main {
    position: relative;
    // padding-top: 24px;
    // height: 100%;
    box-sizing: border-box;
    padding-left: 24px;
    padding-right: 24px;

    .split-line {
        // width: 1380px;
        height: 1px;
        background: #EDF2F2;
        border-radius: 0px 0px 0px 0px;
        margin-top: 14px;
    }

    .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-top: 32px;
    }

    .content-h {
        width: 100%;
        height: 124px;
        background: #F8FAFA;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        box-sizing: border-box;

        .content-h-l {

            display: flex;
            justify-content: space-between;
            align-items: center;

            .content-h-l-c {
                margin-left: 12px;

                .name {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 20px;
                    color: #2F3030;
                    line-height: 28px;
                    text-align: left;
                }

                .sex-m {
                    width: 20px;
                    height: 20px;
                    background: #E4F7F4;
                    border-radius: 2px 2px 2px 2px;
                    text-align: center;
                    color: rgba(45, 93, 207, 1);
                    margin-top: 4px;
                    margin-left: 6px;
                }

                .sex-w {
                    width: 20px;
                    height: 20px;
                    border-radius: 2px 2px 2px 2px;
                    text-align: center;
                    background: #FFE8EC;
                    margin-top: 4px;
                    margin-left: 6px;
                    color: rgba(226, 60, 88, 1)
                }

                .status {
                    width: 54px;
                    height: 24px;
                    background: #E4F7F4;
                    border-radius: 2px 2px 2px 2px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #00B498;
                    line-height: 24px;
                    text-align: center;
                    margin-top: 2px;
                    margin-left: 22px
                }

                .text {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #2F3030;
                    margin-right: 40px;
                }
            }
        }

        .content-h-r {
            .time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #939696;
                line-height: 0px;
                text-align: right;
                margin-top: -30px;
            }
        }
    }

    .content-c {
        margin-top: 30px;

        .l-form {
            color: #2F3030;

            .el-form-item {
                // width: 290px;
                width: 25%;
                margin-right: 0;
            }

            /deep/.el-form-item__label {
                color: #939696;
            }
        }

        .text-f {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #2F3030;
            line-height: 32px;
        }

        .relative {
            width: 100%;
            height: 52px;
            background: #F8FAFA;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .sort-index {
            width: 16px;
            height: 16px;
            background: #E4F7F4;
            line-height: 16px;
            border-radius: 50%;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 12px;
            color: #00B498;
            text-align: center;
        }

        .sort-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 14px;
            color: #2F3030;
            margin-left: 2px;
        }
    }

    .main-content {
        margin-top: 30px;

    }

    .back {
        // width: 1436px;
        height: 68px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: fixed;
        left: 25%;
        right: 0;
        bottom: 0;
        border-top: 1px solid #EDF2F2;

        .back-btn {
            width: 88px;
            height: 36px;
            background: #EDF2F2;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #939696;
            line-height: 36px;
            text-align: center;
            margin-left: 24px;

        }
    }
}
</style>
